import React from 'react';
import PropTypes from 'prop-types';
import CommentQuestionOutlineIcon from 'mdi-react/CommentQuestionOutlineIcon';
import ClipboardTextOutlineIcon from 'mdi-react/ClipboardTextOutlineIcon';
import FormatListChecksIcon from 'mdi-react/FormatListChecksIcon';
import TrophyOutlineIcon from 'mdi-react/TrophyOutlineIcon';
import PodiumIcon from 'mdi-react/PodiumIcon';
import ChartBarIcon from 'mdi-react/ChartBarIcon';
import AccountTieIcon from 'mdi-react/AccountTieIcon';
import EyeOutlineIcon from 'mdi-react/EyeOutlineIcon';
import StadiumIcon from 'mdi-react/StadiumIcon';
import ShieldAccountOutlineIcon from 'mdi-react/ShieldAccountOutlineIcon';
import { partial } from '../../../util/translation/translation';
import FeatureShowcase from '../../../shared/components/custom/FeatureShowcase';
import QuizPreview from './QuizPreview';

/**
 * Questionnaires in two steps: pick a type and build it, then fans answer
 * in the app and the club follows the results.
 */
const QuestionnairesShowcase = ({ collapsible, action }) => {
  const s = partial('shared');
  return (
    <FeatureShowcase
      storageKey="questionnairesShowcaseHidden"
      icon={CommentQuestionOutlineIcon}
      title={s('quizInfoTitle')}
      subtitle={s('quizShowcaseSubtitle')}
      showLabel={s('quizShowcaseShow')}
      uses={[
        {
          key: 'build',
          step: s('showcaseStep', { step: 1 }),
          icon: ClipboardTextOutlineIcon,
          label: s('quizBuildLabel'),
          text: s('quizBuildText'),
          cards: [
            {
              key: 'types',
              icon: ClipboardTextOutlineIcon,
              title: s('quizCardTypes'),
              text: s('quizCardTypesText'),
              points: [
                { label: s('quizTypeQuiz'), text: s('quizTypeQuizText') },
                { label: s('quizTypePoll'), text: s('quizTypePollText') },
                {
                  label: s('quizTypeSurvey'),
                  text: s('quizTypeSurveyText'),
                },
              ],
            },
            {
              key: 'questions',
              icon: FormatListChecksIcon,
              title: s('quizCardQuestions'),
              text: s('quizCardQuestionsText'),
              badges: [
                s('quizQType-choice'),
                s('quizQType-multiple'),
                s('quizQType-score'),
                s('quizQType-player'),
                s('quizQType-text'),
                s('quizQType-image'),
              ],
            },
            {
              key: 'match',
              icon: StadiumIcon,
              title: s('quizCardMatch'),
              text: s('quizCardMatchText'),
            },
            {
              key: 'access',
              icon: ShieldAccountOutlineIcon,
              title: s('quizCardAccess'),
              text: s('quizCardAccessText'),
            },
          ],
        },
        {
          key: 'answer',
          step: s('showcaseStep', { step: 2 }),
          icon: TrophyOutlineIcon,
          label: s('quizAnswerLabel'),
          text: s('quizAnswerText'),
          // A quiz question in the app; answering works
          interactive: true,
          itemsBeside: true,
          preview: <QuizPreview />,
          items: [
            {
              key: 'leaderboard',
              icon: PodiumIcon,
              label: s('quizItemLeaderboard'),
            },
            {
              key: 'answers',
              icon: EyeOutlineIcon,
              label: s('quizItemAnswers'),
            },
            { key: 'stats', icon: ChartBarIcon, label: s('quizItemStats') },
            { key: 'leads', icon: AccountTieIcon, label: s('quizItemLeads') },
          ],
        },
      ]}
      collapsible={collapsible}
      action={action}
    />
  );
};

QuestionnairesShowcase.propTypes = {
  collapsible: PropTypes.bool,
  action: PropTypes.node,
};

QuestionnairesShowcase.defaultProps = {
  collapsible: true,
  action: null,
};

export default QuestionnairesShowcase;
